import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import type { GetIntegrationStatusRequestDto } from "../../dtos/get-integration-status-request-dto";
import type { GetIntegrationStatusResponseDto } from "../../dtos/get-integration-status-response-dto";
import { OrderQueryKeys } from "../../generators/order-query-keys";
import { OrderService } from "../../services/order-service";

type UseGetIntegrationStatusQueryParams = {
  queryParams: GetIntegrationStatusRequestDto;
  options?: Omit<UseQueryOptions<GetIntegrationStatusResponseDto>, "queryKey">;
};

export const useGetIntegrationStatusQuery = ({
  queryParams,
  options
}: UseGetIntegrationStatusQueryParams) => {
  return useQuery({
    queryKey: OrderQueryKeys.getIntegrationStatus(queryParams.orderId).queryKey,
    queryFn: async () =>
      await OrderService.getIntegrationStatus({ payload: queryParams }),
    ...options
  });
};
